<template>
    <div class="card_path" :class="className">
      <div class="card" v-for="(row, index) in cards" :key="index">
        <p class="subtitle-4 bold">{{ $t(row.title) }}</p>
        <img src="/images/forex/Line-20.svg" alt="Línea decorativa" />
        <div class="detail-mobile">
            <div class="opt" v-for="item in row.options" :key="item">
                <div class="icon">
                    <span class="material-symbols-outlined" translate="no">done</span>
                </div>
                <p>{{$t(item)}}</p>
            </div>
        </div>
        
      </div>
    </div>
</template>

<script setup>

defineProps({
  cards: {
    type: Object,
    required: true
  },
  className: {
    type: String,
    default: 'grid2'
  }
});
</script>

  